import { useEffect } from 'react'

export default function Modal({ isOpen, onClose, title, children }) {
  useEffect(() => {
    if (!isOpen) return
    const count = parseInt(document.body.dataset.modals || '0') + 1
    document.body.dataset.modals = count.toString()
    document.body.style.overflow = 'hidden'
    return () => {
      const next = parseInt(document.body.dataset.modals || '1') - 1
      document.body.dataset.modals = next.toString()
      if (next <= 0) {
        document.body.style.overflow = ''
        delete document.body.dataset.modals
      }
    }
  }, [isOpen])

  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ background: 'rgba(0,0,0,0.85)' }}
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-2xl p-6 shadow-2xl bg-surface border border-line"
        onClick={(e) => e.stopPropagation()}
      >
        {title && (
          <div className="flex items-center justify-between mb-5">
            <h2 className="text-lg font-bold">{title}</h2>
            <button
              onClick={onClose}
              className="w-8 h-8 rounded-lg flex items-center justify-center text-xl leading-none transition-colors text-muted hover:text-fg"
            >
              ×
            </button>
          </div>
        )}
        {children}
      </div>
    </div>
  )
}
